var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component"},[_c('router-view'),(_vm.didomiKey)?_c('didomi',{attrs:{"api-key":_vm.didomiKey,"config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }